import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/MEDICATION_FORM_ADMINISTRATION';

interface MedicationAdministrationModalPayload {
    medicationFormId?: string;
    childId: string;
    intendedAdministration?: string;
    referrer?: string;
}

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: MedicationAdministrationModalPayload) => payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
